<template>
  <div class="funds-transfer">
    <div style="position: fixed; top: 50%; left: 50%; z-index: 999;">
      <atom-spinner
        v-if="loading"
        :animation-duration="speed"
        :size="config.size"
        :color="spinnersColor"
      />
    </div>
    <div class="mb-3" v-if="processingError">
      <va-notification color="danger" closeable>       
        An error occurred! Please Try again later.
      </va-notification>
    </div>
    <div class="mb-3" v-if="!canProcess">
      <va-notification color="danger" closeable>       
       Dear member, kindly note that you must be a registered mobile banking user to use this service. Please visit Chuna SACCO offices to register for mobile banking services. Thank you
      </va-notification>
    </div>
    <div class="mb-3" v-if="accErrors">
      <va-notification color="danger" closeable>       
        {{ accErrors }}
      </va-notification>
    </div>
  	<div class="row">
      <div class="flex xs12 md6 lg6" v-if="canProcess">
      	<va-card :title="$t('activities.transfer_form')">
          <form @submit.prevent="onsubmit">
            <va-input
              :label="$t('amount')"
              type="number"
              v-model="formdata.amount"
              :error="!!amountErrors.length"
              :error-messages="amountErrors"
            />
            <va-select
              class="mb-4"
              label="Transfer Type"
              v-model="formdata.type"
              textBy="description"
              :options="TransferTypes"
              key-by="id"
              @input="setSelected"
            />
            <va-select
              v-if = "isInternal||isBosa"
              class="mb-4"
              label="Account"
              v-model="formdata.acc_code"
              textBy="accname"              
              :options="accounts"
              :error = "accError"
              key-by="paybill_code"              
            />
            <va-input
               v-if="isExternal"               
              :label="$t('auth.id_no')"
              v-model="formdata.id_no"           
              :error="!!idErrors.length"
              :error-messages="idErrors"
            />

            <div class="row mt-5">            
              <va-button type="submit" >
                {{ $t('forms.controls.submit') }}
              </va-button>                        
            </div>
          </form>
        </va-card>
      </div>
    </div>
    <va-modal
      v-model="showConfirmModal"
      position="top"
      size = "medium"
      :title=" $t('confirm_trans')"
      cancelClass="none"      
      :okText=" $t('modal.confirm') "     
      :cancelText=" $t('modal.cancel')"      
      noOutsideDismiss
      noEscDismiss
      @ok = "FinalPost"
    >
      <table class="va-table va-table--striped va-table--hoverable" width="100%">
        <tbody>
          <tr>
            <td>Send To</td>
            <td style="text-align: right;">{{ recv_acc_no }}</td>
          </tr>
          <tr>
            <td>Acc Name</td>
            <td style="text-align: right;">{{ recv_acc_name }}</td>
          </tr> 
          <tr>
            <td>Paying Acc Name</td>
            <td style="text-align: right;">{{ accdetails.accname }}</td>
          </tr>
          <tr>
            <td>Paying Acc Balance</td>
            <td style="text-align: right;">{{ accdetails.balance | Currency }}</td>
          </tr>
          <tr>
            <td>Tranfer Amount</td>
            <td style="text-align: right;"> {{ formdata.amount | Currency }} </td>
          </tr> 
          <tr>
            <td>Transaction Charge</td>
            <td style="text-align: right;">{{ cost | Currency }}</td>
          </tr> 
          <tr>
            <td>Total Transaction Cost</td>
            <td style="text-align: right;">{{ formdata.amount - -cost | Currency }}</td>
          </tr>         
        </tbody>
      </table>
    </va-modal>
  </div>
</template>

<script>
import axios from 'axios'
import * as spinners from 'epic-spinners'
export default {
  components: {
    ...spinners      
  },
  name: 'funds-transfer',
  data () {
    return {
      userData: JSON.parse(localStorage.getItem('LoggedUser')),
      accdetails: JSON.parse(localStorage.getItem('UserMianFosa')),
      token: JSON.parse(localStorage.getItem('Token')), 
      recv_acc_no:'',
      recv_acc_name:'',
      cost:'',
      final:{},      
      accounts:JSON.parse(localStorage.getItem('UserFosas')),
      loading: false,      
      processingError: false,
      canProcess : false,
      isInternal:false,
      isBosa:false,
      isExternal:false,
      showConfirmModal : false,
      config: {
        size: 80,
        duration: 1500,
      },
      spinnersColor: this.$themes.secondary,
      currentDuration: 1500,
      sliderDuration: {
        min: 1000,
        max: 2000,
      },
      formdata:{
        amount:'',
        id_no:'',
        user: '',
        type:'', 
        acc_code:'',
      },
      amountErrors : [],
      accErrors : '',
      idErrors : [],
      accError : false,
      TransferTypes: [        
        {
          id: 'internal',
          description: 'FOSA to Others Savings Accounts',
        },
        {
          id: 'bosa',
          description: 'Fosa to Bosa',
        },
        // {
        //   id: 'external',
        //   description: 'My Fosa to Other Members Fosa',
        // },
      ]
    }
  },
  computed: {
    speed () {
      return this.sliderDuration.min + this.sliderDuration.max - this.currentDuration
    },

    formReady () {
        return !this.amountErrors.length && !this.idErrors.length && !this.accError
    }
  }, 
  methods : {
    getSelected(acc_code){
      console.log(acc_code)
      return this.accounts.find(item => 
        item.paybill_code.toLowerCase() == acc_code.toLowerCase()
      )
    },
    setSelected(value){        
      const val = value.id      
        if (val == 'internal'){
          this.isInternal = true
          this.isExternal = false
          this.isBosa = false
          this.accounts = JSON.parse(localStorage.getItem('UserFosas'));
        } 

        if (val == 'bosa'){
          this.isInternal = false
          this.isExternal = false
          this.isBosa = true
          this.accounts = JSON.parse(localStorage.getItem('UserBosas'));
          console.log(this.accounts);
        } 

        if(val == 'external'){
          this.isInternal = false
          this.isExternal = true
          this.isBosa = false
        } 
    },

    onsubmit(){
      this.processingError = false;      
      this.amountErrors = this.formdata.amount ? [] : ['Amount is required']

      if(this.isExternal){
        this.idErrors = this.formdata.id_no  ? [] : ['ID No is required']
      }

      if(this.isInternal || this.isBosa){
        this.accError =  this.formdata.acc_code.paybill_code ? false : true 
        this.accErrors =  this.formdata.acc_code.paybill_code ? null : 'Please Select an Account'
        this.accError =  this.formdata.acc_code.paybill_code != this.accdetails.paybill_code ? false : true
        this.accErrors =  this.formdata.acc_code.paybill_code != this.accdetails.paybill_code ? null : 'Can\'t Transfer Funds to Your Main Account'
      }
      if (this.formReady) {
        let accco = '';
        if(this.isInternal || this.isBosa){
          this.acc_details = this.getSelected(this.formdata.acc_code.paybill_code);
          accco = this.acc_details.paybill_code
        }
        this.loading = true;
        const postdata = {
          amount: this.formdata.amount,
          id_no:this.formdata.id_no,
          user: this.userData.user_id,
          type:this.formdata.type.id, 
          acc_code:accco,
        } 

        var self = this

        let config = {
          headers: {
            Authorization: this.userData.user_id+' '+this.token
          }
        }

        axios.post(`${this.$apiUrl}GetTransferCharge`, postdata, config)
        .then(function (res) {
          self.loading = false        
          const resp = res.data
          self.final = resp
          self.recv_acc_no = self.isExternal ? resp.acc_details.accno : resp.acc_details.acc_number
          self.recv_acc_name = self.isExternal ? resp.acc_details.accname : resp.acc_details.acc_name;
          self.cost = resp.amount;
          self.showConfirmModal = true;
        })
        .catch(function (error) {
            console.log(error)
        })
      }
    },

    FinalPost(){
      var self = this

      let config = {
        headers: {
          Authorization: this.userData.user_id+' '+this.token
        }
      }

      axios.post(`${this.$apiUrl}FundsTransferFosa`, this.final, config)
      .then(function (res) {
        self.loading = false        
        const resp = res.data

        if(resp.response.success == '1'){              
          self.showToast(`Transfer Processed succefully`, {
            position: 'bottom-right',
            icon: "fa-check",
            duration: 2500,
          })
          //setTimeout( () => self.$router.go(-1), 2500);
        } else {
          self.processingError = true
        }           
       
      })
      .catch(function (error) {
          console.log(error)
      })
    }
  },

  created(){
    this.canProcess  = (this.userData.is_registered_mobile_user == 1) ? true : false;
  }
}
</script>
  